import { render } from "./controlpanelpage.vue?vue&type=template&id=1f6901f1&scoped=true&ts=true"
import script from "./controlpanelpage.vue?vue&type=script&lang=ts"
export * from "./controlpanelpage.vue?vue&type=script&lang=ts"

import "./controlpanelpage.vue?vue&type=style&index=0&id=1f6901f1&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f6901f1"]])

export default __exports__